import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { NavigationService } from '../navigation.service';
import { AuthenticationService } from '../../authentication/authentication.service';

@Injectable()
export class ErrorInterceptorService implements HttpInterceptor
{
    constructor(
        private router: Router,
        private navigationService: NavigationService,
        private authService: AuthenticationService) { }

    public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>>
    {
        const isUnauthenticatedAuthRequest = request.url === '/authenticate'
            || request.url === '/authenticate/code/verify'
            || request.url === '/authenticate/code/send';

        return next.handle(request).pipe(
            tap({
                error: (err: any) =>
                {
                    if (err instanceof HttpErrorResponse)
                    {
                        const returnUrl = this.navigationService.getReturnUrl() ? this.navigationService.getReturnUrl() : null;
                        switch (err.status)
                        {
                            case 401:
                                // Login and 2FA endpoints handle their own errors; do not reset session or redirect.
                                // Flowable auth is excluded because in 2FA context the user must enter their code.
                                if (!isUnauthenticatedAuthRequest && !request.url.includes('flowable-idm/app/authentication'))
                                {
                                    this.authService.reset(false, false, true);
                                    this.router.navigate(['login'], returnUrl ? { queryParams: { return: returnUrl } } : {});
                                }
                                break;
                            case 404:
                                // If authenticated, redirect to not-found, otherwise redirect to login
                                this.router.navigate([this.authService.isAuthenticated ? 'not-found' : 'login']);
                                break;
                        }
                        return;
                    }
                }
            }));
    }
}

